<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_12">Part One</h2>
<p class="h3"><span class="color">God the Father</span></p>
<p class="center"><img alt="" src="Images/6464_PART.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PART1.vue?d30cc466